import { domMax, type HTMLMotionProps, LazyMotion, m } from "motion/react";
import * as React from "react";
import { cn } from "../../lib/utils";

export interface StateLayerProps extends HTMLMotionProps<"div"> {
	hovered?: boolean;
	focused?: boolean;
	pressed?: boolean;
}

/**
 * StateLayer provides a standardized visual overlay for interactive states (hover, focus, pressed)
 * following MD3 specifications.
 */
export const StateLayer = React.forwardRef<HTMLDivElement, StateLayerProps>(
	({ className, hovered, focused, pressed, ...props }, ref) => {
		// Determine opacity based on MD3 specs
		let opacity = 0;
		if (pressed) {
			opacity = 0.12;
		} else if (focused) {
			opacity = 0.1;
		} else if (hovered) {
			opacity = 0.08;
		}

		return (
			<LazyMotion features={domMax} strict>
				<m.div
					ref={ref}
					className={cn(
						"absolute inset-0 bg-current pointer-events-none rounded-[inherit]",
						className,
					)}
					initial={false}
					animate={{ opacity }}
					transition={{ duration: 0.2 }}
					aria-hidden="true"
					{...props}
				/>
			</LazyMotion>
		);
	},
);

StateLayer.displayName = "StateLayer";
